import React, { useState, useEffect } from "react";
import { showToast } from "../Toast";

const FloatingInput = ({ ...props }) => {
  let refs = {};
  const [fieldActivate, setFieldActivate] = useState(
    props.value && props.value.length > 0 ? true : false
  );
  const [focused, setFocused] = useState(false);
  useEffect(() => {
    props.value &&
      props.value !== "" &&
      props.value !== [] &&
      props.value.length > 0 &&
      props.value !== undefined &&
      setFieldActivate(true);
  }, [props.value]);
  function activateField() {
    setFieldActivate(true);
    // props.setError(false);
    setFocused(true);
  }
  function disableFocus(e) {
    if (
      (!props.select && e.target.value === "") ||
      (props.select && props.value === "")
    ) {
      setFieldActivate(false);
    }
    setFocused(false);
  }
  function updateInputValue(e) {
    !props.select ? props.setValue(e.target.value) : props.setValue(e);
    activateField(e);
    !props.select && e.preventDefault();
  }
  const labelClass = () => {
    var classname = "";
    if (focused && fieldActivate) {
      classname = `field-active`;
    } else if (!focused && fieldActivate) {
      classname = `field-active-notFocus`;
    } else classname = "";
    return classname;
  };

  const inputClass = () => {
    var classname = "";
    if (focused && fieldActivate) {
      classname = `floating-label border-active `;
    } else if (!focused && fieldActivate) {
      classname = "floating-label border-Notactive";
    } else if (!focused && !fieldActivate && props.error) {
      classname = "floating-label border-error";
    } else classname = "floating-label";
    return classname;
  };
  return (
    <div
      className={
        props.size === 2
          ? "field-group-half"
          : props.size === 1
          ? "field-group-third"
          : `field-group ${props?.big ? "biginput" : ""}`
      }
    >
      <label className={labelClass()} onClick={() => refs.input.focus()}>
        {props.labelShort && (focused || fieldActivate)
          ? props.labelShort
          : props.label}
      </label>

      <input
        // style={!fieldActivate && props.error && { borderColor: "red" }}
        ref={(label) => (refs.input = label)}
        className={inputClass()}
        type={props.type === "tel" ? "tel" : "text"}
        pattern={props.type === "tel" && "[0-9]*"}
        maxlength={props.length ? props.length : 10000}
        value={props.value}
        onFocus={activateField}
        onBlur={disableFocus}
        onChange={updateInputValue}
        disabled={props.disabled ? true : false}
        contentEditable={props.disabled ? false : true}
      />
    </div>
  );
};

export default FloatingInput;
